module.exports = __webpack_public_path__ + "img/dep_clothingandaccessories@2x.751577ab.png";